import type { ZudokuConfig } from "zudoku";
import { extraConfig } from "./src/navigation";
import process from "node:process";

const basePath = process.env?.ZUDOKU_PUBLIC_BASE_PATH ?? import.meta.env.ZUDOKU_PUBLIC_BASE_PATH;

const config: ZudokuConfig = {
  ...extraConfig,
  basePath: basePath,
  site: {
    logo: {
      src: {
        light: "/transact-RGB-noStrap-positive-96px.png",
        dark: "/transact-RGB-noStrap-negative-96px.png"
      },
      alt: "Transact",
      width: "130px"
    },
    title: "Transact API",
    showPoweredBy: false,
    footer: {
      position: "start"
    }
  },
  slots: {
    "footer-after": () => (
      <div className="text-sm text-muted-foreground space-y-6">
        <p>
          This website is for use by developers, IT professionals, or financial advisers who want to
          understand more about connecting to the Transact API. If you are a client or financial
          adviser seeking more general information on Transact, please visit our{" "}
          <a className="underline" href="https://www.transact-online.co.uk">
            company site
          </a>
          .
        </p>
        <p>
          © 2026 Integrated Financial Arrangements Ltd
          <br />
          "Transact" is operated by Integrated Financial Arrangements Ltd. 4th Floor, 2 Gresham
          Street, London, EC2V 7AD. Tel: 020 7608 4900 Fax: 020 7608 5300. (Registered office: as
          above; Registered in England and Wales under number: 03727592). Authorised and regulated
          by the Financial Conduct Authority (entered on the Financial Services Register; no.
          190856).
        </p>
      </div>
    )
  },
  metadata: {
    title: "%s | Transact API",
    favicon: `${basePath ?? ""}/favicon.ico`,
    applicationName: "Transact API"
  },
  sitemap: {
    siteUrl: "https://apidocs.transact-online.co.uk",
    changefreq: "weekly"
  },
  apis: [
    {
      type: "file",
      input: "./target/transact.v1.yaml",
      path: "/api",
      options: {
        showVersionSelect: "always",
        schemaDownload: { enabled: true }
      }
    }
  ],
  docs: {
    publishMarkdown: true,
    defaultOptions: {
      showLastModified: false,
      copyPage: true
    }
  },
  search: {
    type: "pagefind",
    maxSubResults: 3,
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2
    }
  },
  theme: {
    customCss: `
@font-face {
  font-family: 'local-roboto';
  src: url('${basePath ?? ""}/fonts/roboto/Roboto-VariableFont_wdth,wght.ttf') format('truetype');
}

@font-face {
  font-family: 'local-roboto';
  font-style: italic;
  src: url('${basePath ?? ""}/fonts/roboto/Roboto-Italic-VariableFont_wdth,wght.ttf') format('truetype');
}

:root {
  --font-sans: 'local-roboto', Roboto, ui-sans-serif, sans-serif, system-ui;
}

footer > div {
  padding-top: calc(var(--spacing) * 8);
}
    `
  }
};

export default config;
